module.exports = __webpack_public_path__ + "img/Img1@2x.9d5310cb.jpg";